import { Model } from '@vuex-orm/core'
import Article from '@models/helpers/Article'

export default class Rule extends Model {
  static entity = 'rules';  
  
  static fields () {
    return {
      id: this.attr(null),
      article_id: this.attr(null),
      rule_name: this.string(null),
      value: this.number(null),
      json: this.attr(null),
      
      article: this.belongsTo(Article, 'article_id')
    }
  }
}
  